export enum LoggingRequestTypes {
  yearly='YEARLY',
  monthly='MONTHLY',
  daily='DAILY'
}
